import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { injectIntl, FormattedMessage } from "react-intl";
import Range from 'react-rangeslider';

class RangeFieldCmp extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number,
    initialValue: PropTypes.number,
    step: PropTypes.number,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string
    })
  };

  constructor(props) {
    super(props);
    const { input, min, initialValue = min } = props;
    if (
      input.value === undefined ||
      input.value === null ||
      input.value === ""
    ) {
      input.value = initialValue;
    }
  }

  render() {
    const {
      input,
      min,
      max,
      step = 1,
      meta: { touched, error, warning }
    } = this.props;

    return (
      <div className="QuestionForm-answer-range">
        <output>{input.value}</output>
        <Range
          min={min}
          max={max}
          step={step}
          value={input.value}
          labels={{ [min]: min, [max]: max }}
          onChange={input.onChange}
          onChangeStart={input.onDragStart}
          onChangeComplete={input.onDrop}
          tooltip={false}
        />
        {touched &&
          ((error && (
            <span>
              <FormattedMessage id={error} />
            </span>
          )) ||
            (warning && (
              <span>
                <FormattedMessage id={warning} />
              </span>
            )))}
      </div>
    );
  }
}

const RangeField = props => <Field component={RangeFieldCmp} {...props} />;

export default injectIntl(RangeField);



// WEBPACK FOOTER //
// ./src/modules/forms/fields/range-field.js